enum Key {
  LEFT = 37,
  UP = 38,
  RIGHT = 39,
  DOWN = 40,
  ENTER = 13,
  ESC = 27,
  SPACE = 32,
  BACKSPACE = 8,
}

export default Key;
